export default __webpack_public_path__ + "static/media/file_dotted.b72c6a60.svg";